import { FilterOperatorType } from '../components/odata-filter/models/filter-operator-type';
import {
  FilterGroup,
  ODataFilter,
  ODataFilterValues,
  ODataSubFilter
} from '../components/odata-filter/models/odata-filter';
import { FilterOperator, OPERATORS } from '../components/odata-filter/models/operators';
import { SearchValueType } from '../components/odata-filter/models/search-value-type';
import { ChildFieldsFilterModel } from './child-fields-filter-model';
import { CustomFieldFilterModel } from './custom-field-filter-model';
import { ODataFilterBuilder } from './odata-filter-builder';

export class SubConditionFilterModel implements ODataFilter {
  childFieldName = '';
  filterGroup = FilterGroup.SubConditionFilterFields;
  subFilter = new ODataSubFilter();
  constructor(
    public displayName: string,
    public targetField: string,
    public valueType: SearchValueType,
    public values?: any[] | ODataFilterValues[],
    public targetFieldId: string = ''
  ) {}

  buildFilter(
    searchValue: any,
    filterOperator: FilterOperator,
    subQueryFilters?: any[],
    buildForAutomation?: boolean
  ) {
    if (
      this.targetField == 'customFields' ||
      this.targetField == 'trackedCustomFields' ||
      this.targetField == 'values'
    ) {
      return new CustomFieldFilterModel(
        this.filterGroup,
        this.displayName,
        this.targetField,
        this.targetFieldId,
        this.valueType,
        this.values
      ).buildFilter(searchValue, filterOperator);
    }
    if (this.targetField == 'specialties') {
      return new ChildFieldsFilterModel(
        this.targetField,
        this.displayName,
        'specialtyDefinitionId',
        this.valueType,
        this.values
      ).buildFilter(searchValue, filterOperator);
    }
    let operatorTypes = OPERATORS[this.valueType];

    if (
      operatorTypes.operators.findIndex(
        (x) => x.displayOperator == filterOperator.displayOperator
      ) == -1
    ) {
      throw new Error('Invalid Operation');
    }

    if (this.valueType == SearchValueType.Date) {
      return this.getDateFilter(searchValue, filterOperator, buildForAutomation);
    } else {
      return this.getOtherTypeOfFilter(searchValue, filterOperator);
    }
  }
  private getOtherTypeOfFilter(searchValue: any, filterOperator: FilterOperator) {
    let filter: { [k: string]: any } = {};
    if (this.valueType == SearchValueType.String || this.valueType == SearchValueType.Email) {
      let _searchValue =
        filterOperator.displayOperator == FilterOperatorType.isEmpty ||
        filterOperator.displayOperator == FilterOperatorType.isNotEmpty
          ? null
          : searchValue;
      filter =
        this.valueType == SearchValueType.String
          ? ODataFilterBuilder.buildStringFilter(
              this.targetField,
              _searchValue,
              filterOperator.actualOperator,
              true
            )
          : ODataFilterBuilder.buildEmailFilter(
              this.targetField,
              _searchValue,
              filterOperator.actualOperator,
              true
            );
    } else if (this.valueType == SearchValueType.Number) {
      let _searchValue =
        filterOperator.displayOperator == FilterOperatorType.isEmpty ||
        filterOperator.displayOperator == FilterOperatorType.isNotEmpty
          ? 0
          : searchValue;

      filter = ODataFilterBuilder.buildNumberFilter(
        this.targetField,
        _searchValue,
        filterOperator.actualOperator,
        true
      );
    } else if (this.valueType == SearchValueType.MultiValue) {
      let _searchValue =
        searchValue && searchValue.length ? searchValue.map((x) => x.searchValue) : [];
      let _opt =
        filterOperator.displayOperator == FilterOperatorType.notIn
          ? FilterOperatorType.in
          : filterOperator.displayOperator;

      filter = ODataFilterBuilder.buildArrayFilter(this.targetField, _searchValue, _opt, true);
    } else if (
      this.valueType == SearchValueType.Boolean ||
      this.valueType == SearchValueType.List
    ) {
      filter = ODataFilterBuilder.buildSimpleFilter(
        this.targetField,
        searchValue,
        filterOperator.actualOperator,
        true
      );
    } else if (this.valueType == SearchValueType.Guid) {
      filter = ODataFilterBuilder.buildGuidFilter(
        this.targetField,
        searchValue,
        filterOperator.actualOperator,
        true
      );
    }
    if (
      filterOperator.displayOperator == FilterOperatorType.notContains ||
      filterOperator.displayOperator == FilterOperatorType.notIn
    )
      return { not: filter };
    return filter;
  }

  private getDateFilter(
    searchValue: any,
    filterOperator: FilterOperator,
    buildForAutomation: boolean
  ) {
    return ODataFilterBuilder.buildDateFilter(
      this.targetField,
      searchValue,
      filterOperator.displayOperator,
      true,
      buildForAutomation
    );
  }
}
